import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetSiteLocationsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.SiteLocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.SiteLocationDocumentSortInput> | Types.SiteLocationDocumentSortInput>;
}>;


export type GetSiteLocationsQuery = { __typename?: 'Query', siteLocations?: { __typename?: 'SiteLocationsConnection', totalCount: number, edges?: Array<{ __typename?: 'SiteLocationsEdge', node: { __typename?: 'SiteLocationDocument', id: string, tenantId: string, siteLocationId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, usageCount?: number | null, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateDocumentData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeDocumentData', id: string, name: string }>, siteContacts: Array<{ __typename?: 'SiteContactDocumentData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetSiteLocationQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
}>;


export type GetSiteLocationQuery = { __typename?: 'Query', siteLocation?: { __typename?: 'SiteLocationDocument', id: string, tenantId: string, siteLocationId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, usageCount?: number | null, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateDocumentData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeDocumentData', id: string, name: string }>, siteContacts: Array<{ __typename?: 'SiteContactDocumentData', role: Types.SiteContactRole, name: string, email: string, phone: string }> } | null };

export type GetSubLocationsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.SubLocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.SubLocationDocumentSortInput> | Types.SubLocationDocumentSortInput>;
  includeCombined?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetSubLocationsQuery = { __typename?: 'Query', subLocations?: { __typename?: 'SubLocationsConnection', totalCount: number, edges?: Array<{ __typename?: 'SubLocationsEdge', node: { __typename?: 'SubLocationDocument', usageCount?: number | null, id: string, tenantId: string, siteLocationId: string, locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus, pickSequence?: number | null, defaultSpaceTypeId?: string | null, combinedIntoLocationId?: string | null, combinedAt?: Types.TDateISO | null, combinedBy?: string | null, absorbedLocationIds: Array<string>, absorbedErpIds: Array<string>, absorbedNames: Array<string>, created: Types.TDateISO, updated: Types.TDateISO } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetLocationInUseQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  locationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetLocationInUseQuery = { __typename?: 'Query', locationInUse: { __typename?: 'LocationInUsePayload', report?: { __typename?: 'LocationInUseReport', siteLocationId: string, locationId?: string | null, locationIds: Array<string>, inUse: boolean, totals: Array<{ __typename?: 'LocationReferenceTotal', kind: Types.SubLocationReferenceKind, count: number }>, references: Array<{ __typename?: 'SubLocationReference', kind: Types.SubLocationReferenceKind, recordId: string, label: string, quantity?: number | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type GetSubLocationQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  locationId: Types.Scalars['String']['input'];
}>;


export type GetSubLocationQuery = { __typename?: 'Query', subLocation?: { __typename?: 'SubLocationDocument', id: string, tenantId: string, siteLocationId: string, locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus, pickSequence?: number | null, defaultSpaceTypeId?: string | null, combinedIntoLocationId?: string | null, combinedAt?: Types.TDateISO | null, combinedBy?: string | null, absorbedLocationIds: Array<string>, absorbedErpIds: Array<string>, absorbedNames: Array<string>, created: Types.TDateISO, updated: Types.TDateISO } | null };

export type GetSubLocationCombinePreviewQueryVariables = Types.Exact<{
  siteLocationId: Types.Scalars['String']['input'];
  survivorLocationId: Types.Scalars['String']['input'];
  loserLocationId: Types.Scalars['String']['input'];
}>;


export type GetSubLocationCombinePreviewQuery = { __typename?: 'Query', subLocationCombinePreview: { __typename?: 'SubLocationCombinePreviewPayload', preview?: { __typename?: 'SubLocationCombinePreview', conflictCount: number, survivorSuggested: boolean, fields: Array<{ __typename?: 'SubLocationCombineField', key: string, label: string, kind: Types.SubLocationCombineFieldKind, survivorValue?: string | null, loserValue?: string | null, resultValue?: string | null, isConflict: boolean }>, blockers: Array<{ __typename?: 'SubLocationCombineBlocker', kind: Types.SubLocationCombineBlockerKind, recordId: string, label: string }>, survivorHistory: { __typename?: 'SubLocationCombineHistory', inventoryRows: number, inventoryTransactions: number, productionJobs: number, countLogs: number, materialRows: number }, loserHistory: { __typename?: 'SubLocationCombineHistory', inventoryRows: number, inventoryTransactions: number, productionJobs: number, countLogs: number, materialRows: number } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SubLocationCombineHistoryFieldsFragment = { __typename?: 'SubLocationCombineHistory', inventoryRows: number, inventoryTransactions: number, productionJobs: number, countLogs: number, materialRows: number };

export type GetSiteLocationsBasicQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetSiteLocationsBasicQuery = { __typename?: 'Query', siteLocations?: { __typename?: 'SiteLocationsConnection', totalCount: number, edges?: Array<{ __typename?: 'SiteLocationsEdge', node: { __typename?: 'SiteLocationDocument', siteLocationId: string, name: string, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string } | null } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetSiteLocationOptionsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.SiteLocationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.SiteLocationDocumentSortInput> | Types.SiteLocationDocumentSortInput>;
}>;


export type GetSiteLocationOptionsQuery = { __typename?: 'Query', siteLocations?: { __typename?: 'SiteLocationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'SiteLocationDocument', siteLocationId: string, name: string, status: Types.LocationStatus }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetSubLocationsBasicQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.SubLocationDocumentFilterInput>;
}>;


export type GetSubLocationsBasicQuery = { __typename?: 'Query', subLocations?: { __typename?: 'SubLocationsConnection', totalCount: number, edges?: Array<{ __typename?: 'SubLocationsEdge', node: { __typename?: 'SubLocationDocument', siteLocationId: string, locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus, created: Types.TDateISO, updated: Types.TDateISO } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetSiteLocationTypeRelationshipsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSiteLocationTypeRelationshipsQuery = { __typename?: 'Query', siteLocationTypeRelationships: { __typename?: 'SiteLocationTypeRelationships', rootTypes: Array<Types.SiteLocationType>, parentToChildren: Array<{ __typename?: 'ParentChildRelationship', parent: Types.SiteLocationType, validChildren: Array<Types.SiteLocationType> }>, childToParents: Array<{ __typename?: 'ChildParentRelationship', child: Types.SiteLocationType, validParents: Array<Types.SiteLocationType> }> } };

export type SiteLocationFieldsFragment = { __typename?: 'SiteLocationDocument', id: string, tenantId: string, siteLocationId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, usageCount?: number | null, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateDocumentData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeDocumentData', id: string, name: string }>, siteContacts: Array<{ __typename?: 'SiteContactDocumentData', role: Types.SiteContactRole, name: string, email: string, phone: string }> };

export type SubLocationFieldsFragment = { __typename?: 'SubLocationDocument', id: string, tenantId: string, siteLocationId: string, locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus, pickSequence?: number | null, defaultSpaceTypeId?: string | null, combinedIntoLocationId?: string | null, combinedAt?: Types.TDateISO | null, combinedBy?: string | null, absorbedLocationIds: Array<string>, absorbedErpIds: Array<string>, absorbedNames: Array<string>, created: Types.TDateISO, updated: Types.TDateISO };

export type LocationInUseReportFieldsFragment = { __typename?: 'LocationInUseReport', siteLocationId: string, locationId?: string | null, locationIds: Array<string>, inUse: boolean, totals: Array<{ __typename?: 'LocationReferenceTotal', kind: Types.SubLocationReferenceKind, count: number }>, references: Array<{ __typename?: 'SubLocationReference', kind: Types.SubLocationReferenceKind, recordId: string, label: string, quantity?: number | null }> };

export type SiteLocationStateFieldsFragment = { __typename?: 'SiteLocationStateData', id: string, tenantId: string, name: string, erpId: string, status: Types.LocationStatus, timeZone?: string | null, created: Types.TDateISO, updated: Types.TDateISO, address?: { __typename?: 'SiteAddressData', id: string, toName: string, addressLine1: string, addressLine2: string, city: string, stateProvince: string, zipcode: string, country: string, latitude?: number | null, longitude?: number | null } | null, laborRates: Array<{ __typename?: 'SiteLaborRateStateData', laborTypeId: string, ratePerHour: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null }>, laborTypes: Array<{ __typename?: 'LaborTypeStateData', id: string, name: string }>, locations: Array<{ __typename?: 'LocationStateData', locationId: string, name: string, parentLocationId: string, locationType: Types.SiteLocationType, erpId: string, status: Types.LocationStatus }>, overheadRate?: { __typename?: 'OverheadRateStateData', costPerSqFtPerWeek: number, effectiveFrom: Types.TDateISO, effectiveTo?: Types.TDateISO | null } | null, siteContacts: Array<{ __typename?: 'SiteContactStateData', role: Types.SiteContactRole, name: string, email: string, phone: string }> };

export const SubLocationCombineHistoryFieldsFragmentDoc = new TypedDocumentString(`
    fragment SubLocationCombineHistoryFields on SubLocationCombineHistory {
  inventoryRows
  inventoryTransactions
  productionJobs
  countLogs
  materialRows
}
    `, {"fragmentName":"SubLocationCombineHistoryFields"});
export const SiteLocationFieldsFragmentDoc = new TypedDocumentString(`
    fragment SiteLocationFields on SiteLocationDocument {
  id
  tenantId
  siteLocationId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  siteContacts {
    role
    name
    email
    phone
  }
  usageCount
}
    `, {"fragmentName":"SiteLocationFields"});
export const SubLocationFieldsFragmentDoc = new TypedDocumentString(`
    fragment SubLocationFields on SubLocationDocument {
  id
  tenantId
  siteLocationId
  locationId
  name
  parentLocationId
  locationType
  erpId
  status
  pickSequence
  defaultSpaceTypeId
  combinedIntoLocationId
  combinedAt
  combinedBy
  absorbedLocationIds
  absorbedErpIds
  absorbedNames
  created
  updated
}
    `, {"fragmentName":"SubLocationFields"});
export const LocationInUseReportFieldsFragmentDoc = new TypedDocumentString(`
    fragment LocationInUseReportFields on LocationInUseReport {
  siteLocationId
  locationId
  locationIds
  inUse
  totals {
    kind
    count
  }
  references {
    kind
    recordId
    label
    quantity
  }
}
    `, {"fragmentName":"LocationInUseReportFields"});
export const SiteLocationStateFieldsFragmentDoc = new TypedDocumentString(`
    fragment SiteLocationStateFields on SiteLocationStateData {
  id
  tenantId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  locations {
    locationId
    name
    parentLocationId
    locationType
    erpId
    status
  }
  overheadRate {
    costPerSqFtPerWeek
    effectiveFrom
    effectiveTo
  }
  siteContacts {
    role
    name
    email
    phone
  }
}
    `, {"fragmentName":"SiteLocationStateFields"});
export const GetSiteLocationsDocument = new TypedDocumentString(`
    query GetSiteLocations($first: Int, $after: String, $where: SiteLocationDocumentFilterInput, $order: [SiteLocationDocumentSortInput!]) {
  siteLocations(first: $first, after: $after, where: $where, order: $order) {
    edges {
      node {
        ...SiteLocationFields
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SiteLocationFields on SiteLocationDocument {
  id
  tenantId
  siteLocationId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  siteContacts {
    role
    name
    email
    phone
  }
  usageCount
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetSiteLocationDocument = new TypedDocumentString(`
    query GetSiteLocation($siteLocationId: String!) {
  siteLocation(siteLocationId: $siteLocationId) {
    ...SiteLocationFields
  }
}
    fragment SiteLocationFields on SiteLocationDocument {
  id
  tenantId
  siteLocationId
  name
  erpId
  status
  timeZone
  created
  updated
  address {
    id
    toName
    addressLine1
    addressLine2
    city
    stateProvince
    zipcode
    country
    latitude
    longitude
  }
  laborRates {
    laborTypeId
    ratePerHour
    effectiveFrom
    effectiveTo
  }
  laborTypes {
    id
    name
  }
  siteContacts {
    role
    name
    email
    phone
  }
  usageCount
}`);
export const GetSubLocationsDocument = new TypedDocumentString(`
    query GetSubLocations($first: Int, $after: String, $where: SubLocationDocumentFilterInput, $order: [SubLocationDocumentSortInput!], $includeCombined: Boolean) {
  subLocations(
    first: $first
    after: $after
    where: $where
    order: $order
    includeCombined: $includeCombined
  ) {
    edges {
      node {
        ...SubLocationFields
        usageCount
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment SubLocationFields on SubLocationDocument {
  id
  tenantId
  siteLocationId
  locationId
  name
  parentLocationId
  locationType
  erpId
  status
  pickSequence
  defaultSpaceTypeId
  combinedIntoLocationId
  combinedAt
  combinedBy
  absorbedLocationIds
  absorbedErpIds
  absorbedNames
  created
  updated
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetLocationInUseDocument = new TypedDocumentString(`
    query GetLocationInUse($siteLocationId: String!, $locationId: String) {
  locationInUse(siteLocationId: $siteLocationId, locationId: $locationId) {
    report {
      ...LocationInUseReportFields
    }
    errors {
      code
      message
    }
  }
}
    fragment LocationInUseReportFields on LocationInUseReport {
  siteLocationId
  locationId
  locationIds
  inUse
  totals {
    kind
    count
  }
  references {
    kind
    recordId
    label
    quantity
  }
}`);
export const GetSubLocationDocument = new TypedDocumentString(`
    query GetSubLocation($siteLocationId: String!, $locationId: String!) {
  subLocation(siteLocationId: $siteLocationId, locationId: $locationId) {
    ...SubLocationFields
  }
}
    fragment SubLocationFields on SubLocationDocument {
  id
  tenantId
  siteLocationId
  locationId
  name
  parentLocationId
  locationType
  erpId
  status
  pickSequence
  defaultSpaceTypeId
  combinedIntoLocationId
  combinedAt
  combinedBy
  absorbedLocationIds
  absorbedErpIds
  absorbedNames
  created
  updated
}`);
export const GetSubLocationCombinePreviewDocument = new TypedDocumentString(`
    query GetSubLocationCombinePreview($siteLocationId: String!, $survivorLocationId: String!, $loserLocationId: String!) {
  subLocationCombinePreview(
    siteLocationId: $siteLocationId
    survivorLocationId: $survivorLocationId
    loserLocationId: $loserLocationId
  ) {
    preview {
      conflictCount
      survivorSuggested
      fields {
        key
        label
        kind
        survivorValue
        loserValue
        resultValue
        isConflict
      }
      blockers {
        kind
        recordId
        label
      }
      survivorHistory {
        ...SubLocationCombineHistoryFields
      }
      loserHistory {
        ...SubLocationCombineHistoryFields
      }
    }
    errors {
      code
      message
    }
  }
}
    fragment SubLocationCombineHistoryFields on SubLocationCombineHistory {
  inventoryRows
  inventoryTransactions
  productionJobs
  countLogs
  materialRows
}`);
export const GetSiteLocationsBasicDocument = new TypedDocumentString(`
    query GetSiteLocationsBasic($first: Int, $after: String) {
  siteLocations(first: $first, after: $after) {
    edges {
      node {
        siteLocationId
        name
        erpId
        status
        created
        updated
        address {
          id
          toName
          addressLine1
          addressLine2
          city
          stateProvince
          zipcode
          country
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `);
export const GetSiteLocationOptionsDocument = new TypedDocumentString(`
    query GetSiteLocationOptions($first: Int, $after: String, $last: Int, $before: String, $where: SiteLocationDocumentFilterInput, $order: [SiteLocationDocumentSortInput!]) {
  siteLocations(
    first: $first
    after: $after
    last: $last
    before: $before
    where: $where
    order: $order
  ) {
    nodes {
      siteLocationId
      name
      status
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetSubLocationsBasicDocument = new TypedDocumentString(`
    query GetSubLocationsBasic($first: Int, $after: String, $where: SubLocationDocumentFilterInput) {
  subLocations(first: $first, after: $after, where: $where) {
    edges {
      node {
        siteLocationId
        locationId
        name
        parentLocationId
        locationType
        erpId
        status
        created
        updated
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
  }
}
    `);
export const GetSiteLocationTypeRelationshipsDocument = new TypedDocumentString(`
    query GetSiteLocationTypeRelationships {
  siteLocationTypeRelationships {
    parentToChildren {
      parent
      validChildren
    }
    childToParents {
      child
      validParents
    }
    rootTypes
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetSiteLocations: build.query<GetSiteLocationsQuery, GetSiteLocationsQueryVariables | void>({
      query: (variables) => ({ document: GetSiteLocationsDocument, variables })
    }),
    GetSiteLocation: build.query<GetSiteLocationQuery, GetSiteLocationQueryVariables>({
      query: (variables) => ({ document: GetSiteLocationDocument, variables })
    }),
    GetSubLocations: build.query<GetSubLocationsQuery, GetSubLocationsQueryVariables | void>({
      query: (variables) => ({ document: GetSubLocationsDocument, variables })
    }),
    GetLocationInUse: build.query<GetLocationInUseQuery, GetLocationInUseQueryVariables>({
      query: (variables) => ({ document: GetLocationInUseDocument, variables })
    }),
    GetSubLocation: build.query<GetSubLocationQuery, GetSubLocationQueryVariables>({
      query: (variables) => ({ document: GetSubLocationDocument, variables })
    }),
    GetSubLocationCombinePreview: build.query<GetSubLocationCombinePreviewQuery, GetSubLocationCombinePreviewQueryVariables>({
      query: (variables) => ({ document: GetSubLocationCombinePreviewDocument, variables })
    }),
    GetSiteLocationsBasic: build.query<GetSiteLocationsBasicQuery, GetSiteLocationsBasicQueryVariables | void>({
      query: (variables) => ({ document: GetSiteLocationsBasicDocument, variables })
    }),
    GetSiteLocationOptions: build.query<GetSiteLocationOptionsQuery, GetSiteLocationOptionsQueryVariables | void>({
      query: (variables) => ({ document: GetSiteLocationOptionsDocument, variables })
    }),
    GetSubLocationsBasic: build.query<GetSubLocationsBasicQuery, GetSubLocationsBasicQueryVariables | void>({
      query: (variables) => ({ document: GetSubLocationsBasicDocument, variables })
    }),
    GetSiteLocationTypeRelationships: build.query<GetSiteLocationTypeRelationshipsQuery, GetSiteLocationTypeRelationshipsQueryVariables | void>({
      query: (variables) => ({ document: GetSiteLocationTypeRelationshipsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetSiteLocationsQuery, useLazyGetSiteLocationsQuery, useGetSiteLocationQuery, useLazyGetSiteLocationQuery, useGetSubLocationsQuery, useLazyGetSubLocationsQuery, useGetLocationInUseQuery, useLazyGetLocationInUseQuery, useGetSubLocationQuery, useLazyGetSubLocationQuery, useGetSubLocationCombinePreviewQuery, useLazyGetSubLocationCombinePreviewQuery, useGetSiteLocationsBasicQuery, useLazyGetSiteLocationsBasicQuery, useGetSiteLocationOptionsQuery, useLazyGetSiteLocationOptionsQuery, useGetSubLocationsBasicQuery, useLazyGetSubLocationsBasicQuery, useGetSiteLocationTypeRelationshipsQuery, useLazyGetSiteLocationTypeRelationshipsQuery } = injectedRtkApi;
